import React from 'react';
import FilterTable from './filterTable';
import {complexColumn} from './tableUtils';

const WebViewerLicenseHistoryTable = (props) => {
  const columns = [{
      dataField: 'eventDateTime',
      text: 'Event time',
      sort: true,
      filter_: { type: 'datetime' },
    }, {
      dataField: 'eventName',
      text: 'Event name',
      sort: true,
      filter_: { type: 'text' },
    }, {
      dataField: 'user.login',
      text: 'User',
      sort: true,
      filter_: { type: 'text' },
    }, {
      dataField: 'info',
      text: 'Info',
      sort: true,
      filter_: { type: 'text' }
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="webViewerLicensesHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        info: complexColumn(histrec, [{
          fields: 'featurePackage.name',
          label: 'Feature package'
        }])
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no web viewer license history records"
    />
  );
};

export default WebViewerLicenseHistoryTable;


// WEBPACK FOOTER //
// ./src/components/webViewerLicenseHistoryTable.js